SP.lang.Class.define("SP.sitekit.form.field.Number", {
	extend: "SP.sitekit.form.field.Field",

	init: function (el, options) {
		this._super.apply(this, arguments);
	},

	getValue: function () {
		if (SP.isEmpty(this._control.value) && this._control && this._control.validity) {
			if (this._control.validity.badInput) {
				return NaN;
			} else {
				return "";
			}
		} else {
			return this._control.value;
		}
	}
});
